// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-pop-input {\n  margin-top: -30px !important;\n}\n", ""]);
// Exports
module.exports = exports;
